export default {
  data() {
    return {
      GroupOperation: {
        And: 'and',
        Or: 'or',
        NotAnd: 'notAnd',
        NotOr: 'notOr'
      },

      RuleType: {
        Wave: 'wave',
        Scenario: 'scenario',
        Property: 'property',
        Location: 'location'
      },

      RuleOperation: {
        Equals: '=',
        NotEquals: '<>',
        GreaterOrEqual: '>='
      }
    }
  },

  computed: {
  },

  methods: {
    getGroupOperationOptions() {
      return [
        { value: this.GroupOperation.And, text: 'AND' },
        { value: this.GroupOperation.Or, text: 'OR' },
        { value: this.GroupOperation.NotAnd, text: 'NOT AND' },
        { value: this.GroupOperation.NotOr, text: 'NOT OR' },
      ];
    },

    getRuleTypeOptions() {
      return [
        { value: this.RuleType.Wave, text: this.getRuleTypeText(this.RuleType.Wave) },
        { value: this.RuleType.Scenario, text: this.getRuleTypeText(this.RuleType.Scenario) },
        { value: this.RuleType.Property, text: this.getRuleTypeText(this.RuleType.Property) },
        { value: this.RuleType.Location, text: this.getRuleTypeText(this.RuleType.Location) },
      ];
    },

    getRuleTypeText(operation) {
      switch (operation) {
        case this.RuleType.Wave: return this.$t('Webportal.Wave');
        case this.RuleType.Scenario: return this.$t('Webportal.Scenario');
        case this.RuleType.Property: return this.$t('Webportal.Property');
        case this.RuleType.Location: return this.$t('Webportal.Location');
      };
    },

    getRuleOperationOptions(type) {
      return [
        { value: this.RuleOperation.Equals, text: this.getRuleOperationText(this.RuleOperation.Equals) },
        { value: this.RuleOperation.NotEquals, text: this.getRuleOperationText(this.RuleOperation.NotEquals) },
        ... type == 'wave' ? [{ value: this.RuleOperation.GreaterOrEqual, text: this.getRuleOperationText(this.RuleOperation.GreaterOrEqual) } ] : [],
      ];
    },

    getRuleOperationText(operation) {
      switch (operation) {
        case this.RuleOperation.Equals: return this.$t('Webportal.RuleBuilder.Operation.Equals');
        case this.RuleOperation.NotEquals: return this.$t('Webportal.RuleBuilder.Operation.NotEquals');
        case this.RuleOperation.GreaterOrEqual: return this.$t('Webportal.RuleBuilder.Operation.GreaterOrEqual');
      };
    },

    getRuleValueObject(rule) {
      if (rule?.value == null)
        return null;

      if (rule.type === this.RuleType.Wave && this.options.waves?.[0]?.children != null)
        return this.options.waves[0].children.find(w => w.id == rule.value);
      else if (rule.type === this.RuleType.Scenario && this.options.scenarios?.[0]?.children != null)
        return this.options.scenarios[0].children.find(s => s.id == rule.value);
      else if (rule.type === this.RuleType.Property && this.options.propertiesFlat != null)
        return this.options.propertiesFlat.find(p => p.id == rule.value);
      else if (rule.type === this.RuleType.Location && this.options.clientLocations != null)
        return this.options.clientLocations.find(cl => cl.id == rule.value);

      return null;
    },

    isRuleTypeValid(ruleType) {
      return [this.RuleType.Wave, this.RuleType.Scenario, this.RuleType.Property, this.RuleType.Location].includes(ruleType);
    },

    isRuleOperationValid(RuleOperation) {
      return [this.RuleOperation.Equals, this.RuleOperation.NotEquals, this.RuleOperation.GreaterOrEqual].includes(RuleOperation)
    },

    isRuleItemValid(item) {
      if (item == null)
        return false;

      if (item.operation == null)
        return false;

      if (item.type != null) {
        // rule
        if (!this.isRuleTypeValid(item.type))
          return false;

        if (!this.isRuleOperationValid(item.operation))
          return false;

        if (item.value == null || this.getRuleValueObject(item) == null)
          return false;
      }
      else {
        // group
        if (![this.GroupOperation.And, this.GroupOperation.Or, this.GroupOperation.NotAnd, this.GroupOperation.NotOr].includes(item.operation))
          return false;

        if (item.children == null || item.children.length == 0)
          return false;
      }

      return true;
    }
  }
};
